export default "__VITE_ASSET__BVUyIM7g__"